import { ICON_HEIGHT_16 } from '../../../../Icon'

import SearchIcon from '../../../../../icons/search.svg'

export const PDF_VIEWER_TOOLBAR_SEARCH_ICON_PROPS = {
  Icon: SearchIcon,
  svgSize: ICON_HEIGHT_16,
}

export const QA_NAME_PDF_VIEWER_TOOLBAR_SEARCH_BTN = 'pdfViewerToolbarSearch'
